import { TextFieldProps } from "@mui/material";
import { FieldProps } from "formik";
import React from "react";
import FormikTextField from "./FormikTextField";

interface Props {}

const FormikNumberField: React.FC<FieldProps & TextFieldProps & Props> = (
  props
) => {
  return (
    <FormikTextField
      {...props}
      type="number"
      sx={{
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
          {
            display: "none",
          },
      }}
    />
  );
};

export default FormikNumberField;
